import React from 'react';
import { Redirect as RedirectComponent } from 'react-router';

function Redirect() {
  return <RedirectComponent to={'/'} />;
}

export default React.memo(Redirect);
